export default class StringUtils {
  /**
   * @description random string generation for guid
   * @retuns {string}
   */
  static randString = () => {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
  };

  /**
   * @description guid generator
   * @retuns {string}
   */
  static guidGenerator = () => {
    return (
      StringUtils.randString() +
      StringUtils.randString() +
      "-" +
      StringUtils.randString() +
      "-4" +
      StringUtils.randString().substr(0, 3) +
      "-" +
      StringUtils.randString() +
      "-" +
      StringUtils.randString() +
      StringUtils.randString() +
      StringUtils.randString()
    ).toLowerCase();
  };

  /**
   * @description gets file extension from filepath
   * @param {string} filename - file path
   * @returns {string}
   */
  static getFileExtension = (filename: string) => {
    if (!filename) return "";

    let fName: string = filename.substring(filename.lastIndexOf(".") + 1, filename.length) || filename;
    return fName.toUpperCase();
  };

  /**
   * @description reverses string
   * @param {string} string data
   * @returns {string}
   */
  static stringReverse = (val: string) => {
    var newstring = "";
    for (var s = 0; s < val.length; s++) {
      newstring = val.charAt(s) + newstring;
    }
    return newstring;
  };

  /**
   * @description returns number
   * @param
   * @returns {number}
   */
  static generatePkID = () => {
    var length = 8;
    var timestamp = +new Date();

    var _getRandomInt = function(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    };

    var ts = timestamp.toString();
    var parts = ts.split("").reverse();
    var id = "";

    for (var i = 0; i < length; ++i) {
      var index = _getRandomInt(0, parts.length - 1);
      id += parts[index];
    }

    return id;
  };

  static redactEmail = (val: string): string => {
    let returnVal: string = "";

    if (val && val.length > 0) {
      let arStrings: string[] = val.split("@");

      if (arStrings.length == 2 && arStrings[0].length > 0) {
        returnVal = returnVal + val.substr(0, 2) + "*".repeat(arStrings[0].length - 1) + "@" + arStrings[1];
      }
    }

    return returnVal;
  };

  /**
   * @description Returns true if any of the arguments has a value.
   * @static
   * @param {...string[]} args
   * @returns {boolean}
   * @memberof StringUtils
   */
  static anyHasValue(...args: string[]): boolean {
    return args.reduce<boolean>((previousValue, currentValue) => {
      return previousValue || (currentValue || "").length > 0;
    }, false);
  }

  static arrayToString = (byteArray: Uint8Array): string => {
    return Array.prototype.map
      .call(byteArray, byte => {
        return ("0" + (byte & 0xff).toString(16)).slice(-2);
      })
      .join("");
  };

  static stringToArray = (hexString: string): Uint8Array => {
    var result = [];
    while (hexString.length >= 2) {
      result.push(parseInt(hexString.substring(0, 2), 16));
      hexString = hexString.substring(2, hexString.length);
    }
    return new Uint8Array(result);
  };

  static capitalizeFirstLetter = (workflowAction: string): string => {
    return workflowAction.charAt(0).toUpperCase() + workflowAction.slice(1);
  };
}
